/**
 * Copia texto al portapapeles. Devuelve `true` si se logró.
 *
 * Usa la Clipboard API (requiere HTTPS, que es como corre la app) y cae a un
 * `<textarea>` temporal cuando el navegador la bloquea — pasa en contextos no
 * seguros y en algunos WebView de celular, donde `navigator.clipboard` ni
 * siquiera existe.
 */
export async function copiarTexto(texto: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(texto);
      return true;
    }
  } catch {
    // Permiso denegado o contexto inseguro — se intenta el fallback de abajo.
  }

  try {
    const ta = document.createElement("textarea");
    ta.value = texto;
    ta.setAttribute("readonly", "");
    // Fuera de la vista pero enfocable: si queda con display:none no se puede
    // seleccionar, y position:fixed evita que la página brinque al enfocarlo.
    ta.style.position = "fixed";
    ta.style.top = "0";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
